'use client';

import { useEventLogger } from './useEventLogger';
import { ClientEvent, EventId } from '@kouzoh/client-event-logger';
import { useEffect } from 'react';

export type LogScreenDisplayProps = {
  location: string;
  eventParams?: ClientEvent;
};

/**
 * LogScreenDisplay is a component that logs a screen display event to avoid use `use client;` in the top level component
 */
export function LogScreenDisplay({ location, eventParams }: LogScreenDisplayProps) {
  const { log } = useEventLogger();
  useEffect(() => {
    log({
      type: EventId.SCREEN_DISPLAY,
      location,
      ...eventParams,
    });
  }, [log]);
  return null;
}
